import { useFormContext } from 'react-hook-form'

import { FormControl, FormError, FormField, FormItem, FormLabel, Input, Textarea } from '@fortem-monorepo/react-ui'

import type { DailyCorrectionValues } from './correction.schema'

export const DailyCorrectionFormFields = ({ disabled }: { disabled: boolean }) => {
  const { control } = useFormContext<DailyCorrectionValues>()
  return (
    <fieldset disabled={disabled} className="space-y-4">
      <FormField
        control={control}
        name="amount"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Daily amount</FormLabel>
              <FormError />
            </div>
            <FormControl>
              <Input inputSize="sm" inputMode="decimal" {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Reason (11–200 characters)</FormLabel>
              <FormError />
            </div>
            <FormControl>
              <Textarea maxLength={200} {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </fieldset>
  )
}
